import React, { useEffect, useState } from 'react'
import { MdStar } from "react-icons/md";
import { MdArrowForwardIos } from "react-icons/md";

export const ChooseCondition = ({setCondition, condition, setDesc, desc, error, setError}) => {
  
  return (
    <div className="relative w-full flex flex-col gap-2" id="setCondition">
      <div>
        <h2 className="text-sm font-medium text-gray-900">Vælg bogens stand</h2>
      </div>
      {(error !== '') ? <h2 className="text-sm font-medium text-gray-900 text-red-500">{error}</h2> : ""}
        <div className="relative">
          <select value={condition} onChange={(e) => setCondition(Number(e.target.value))} className="ring-1 ring-neutral-300 focus:ring-emerald-700 focus:ring-2 text-gray-900 bg-white w-full p-4 ps-5 md:ps-10 outline-none text-sm sm:text-base appearance-none">
            <option value={0} disabled>Vælg stand</option>
            <option value={1}>Slidt</option>
            <option value={2}>God</option>
            <option value={3}>Som ny</option>
          </select>
          <div className="absolute inset-y-0 right-5 flex items-center pointer-events-none">
            <MdArrowForwardIos className="rotate-90" />
          </div>
        </div>
        {/*<div className={"relative w-full box-border text-center p-10 px-16 gap-y-2 border border-neutral-100 flex flex-col cursor-pointer transition-[background-color_0.2s] " + (condition === 1 ? "bg-gradient-to-r from-emerald-600 to-emerald-700 bg-size-200 bg-pos-0 text-white" : "hover:bg-neutral-100")} onClick={() => setCondition(1)}>
          <div className="stars text-xl flex justify-center">
            <MdStar />
          </div>
          <div className="title text-base font-semibold">
            Meget brugt
          </div>
          <div className="desc md:text-xs lg:text-sm">
            Tydelige slidtegn, krøllet omslag, muligvis noter og pletter. Alle sider intakte.
          </div>
        </div>
        <div className={"relative w-full box-border text-center p-10 px-16 gap-y-2 border border-neutral-100 flex flex-col cursor-pointer transition-[background-color_0.2s] " + (condition === 2 ? "bg-gradient-to-r from-emerald-600 to-emerald-700 bg-size-200 bg-pos-0 text-white" : "hover:bg-neutral-100")} onClick={() => setCondition(2)}>
          <div className="stars text-xl flex justify-center">
            <MdStar />
            <MdStar />
          </div>
          <div className="title text-base font-semibold">
            Lettere brugt
          </div>
          <div className="desc md:text-xs lg:text-sm">
            Mindre tegn på brug, bøjede hjørner, muligvis enkelte noter. God stand.
          </div>
        </div>
        <div className={"relative w-full box-border text-center p-10 px-16 gap-y-2 border border-neutral-100 flex flex-col cursor-pointer transition-[background-color_0.2s] " + (condition === 3 ? "bg-gradient-to-r from-emerald-600 to-emerald-700 bg-size-200 bg-pos-0 text-white" : "hover:bg-neutral-100")} onClick={() => setCondition(3)}>
          <div className="stars text-xl flex justify-center">
            <MdStar />
            <MdStar />
            <MdStar />
          </div>
          <div className="title text-base font-semibold">
            Som ny
          </div>
          <div className="desc md:text-xs lg:text-sm">
            Næsten ubrugt, ingen synlige slidtegn eller markeringer. Perfekt stand.
          </div>
        </div>*/}
      <textarea defaultValue={desc} onChange={(e) => (setDesc(e.target.value))} className="block w-full ring-1 ring-neutral-300 focus:ring-emerald-700 focus:ring-2 focus:outline-none p-8 ps-5 md:ps-10 text-sm text-gray-900" placeholder="Evt. relevante detaljer ..." />
    </div>
  )
}